import type { CodeBook } from "@king-ict/eupisi-ui/models";

import type { ProgramCodeBook } from "../../../models/Program";

export const getTotalProgramDuration = (program: ProgramCodeBook): number => {
  const detail = program.ministerDetail;
  return (
    (Number(detail?.guidedLearningDuration) || 0) +
    (Number(detail?.workLearningDuration) || 0) +
    (Number(detail?.independentLearningDuration) || 0)
  );
};

export const getSelectedCodeBookNames = (
  ids: number[] | undefined,
  data: CodeBook[] | undefined,
  empty = "--",
): string => {
  if (!ids || ids.length === 0) {
    return empty;
  }
  return data?.filter((item) => ids.includes(item.id)).map((item) => item.name).join(", ") || empty;
};

export const upsertOtherList = (
  ids: number[],
  otherId: number,
  previousOtherList: string[] | undefined,
): string[] => {
  if (!ids.includes(otherId)) {
    return [];
  }
  return previousOtherList && previousOtherList.length > 0 ? previousOtherList : [""];
};

